// extracted by mini-css-extract-plugin
module.exports = {"root":"BreakingNewsAlert_root__K4D87","hidden":"BreakingNewsAlert_hidden__8MCnX","alert":"BreakingNewsAlert_alert__6Qtyg"};